import { useTranslation } from "react-i18next";
import { MAX_DISCOUNT_PERCENT } from "@nh/shared";

export interface PackagesMetaProps {
  count: number;
}

export function PackagesMeta({ count }: PackagesMetaProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap items-baseline justify-between gap-x-6 gap-y-1">
      <p aria-live="polite" className="text-[13px] font-medium text-ds-ink-3">
        {count === 1 ? t("{{n}} paquete", { n: count }) : t("{{n}} paquetes", { n: count })}
      </p>
      <p className="text-[13px] text-ds-ink-3">
        {t("Hasta un {{n}}% de descuento", { n: MAX_DISCOUNT_PERCENT.franchisee })}
      </p>
    </div>
  );
}
